<template>
  <div class="text-center" :class="{ 'displayNone': displayNone }">
    <img src="https://cdn.carizy.com/images/carizy_loader.gif" alt="Loader">
  </div>
</template>

<script>
  export default {
    name: "SpinnerThreeBounce",

    props: {
      displayNone: {
        type: Boolean
      }
    }
  }
</script>

<style scoped>

</style>

